// extracted by mini-css-extract-plugin
export default {"container":"ScoreWidget_container__xH8+a","container__content":"ScoreWidget_container__content__HpdDF"};